import type { HNSkjemaFrontend } from '../types/Resources';

import { LanguageLocales } from './portalLanguage-utils';
import defaultResource from '../resources/HN.Skjema.Frontend.nb-NO.json';

import { sjekkInputErIkkeTom } from '.';

export const stringToLanguageLocales = (languageString?: LanguageLocales): LanguageLocales => {
  const language = languageString?.toString().toLowerCase();
  switch (language) {
    case LanguageLocales.NORWEGIAN_NYNORSK.toLowerCase():
      return LanguageLocales.NORWEGIAN_NYNORSK;
    case LanguageLocales.ENGLISH.toLowerCase():
      return LanguageLocales.ENGLISH;
    case LanguageLocales.LITHUANIAN.toLowerCase():
      return LanguageLocales.LITHUANIAN;
    case LanguageLocales.POLISH.toLowerCase():
      return LanguageLocales.POLISH;
    case LanguageLocales.RUSSIAN.toLowerCase():
      return LanguageLocales.RUSSIAN;
    case LanguageLocales.ROMANIAN.toLowerCase():
      return LanguageLocales.ROMANIAN;
    case LanguageLocales.SAMI_NORTHERN.toLowerCase():
      return LanguageLocales.SAMI_NORTHERN;
    case LanguageLocales.FRENCH.toLowerCase():
      return LanguageLocales.FRENCH;
    case LanguageLocales.UKRAINIAN.toLowerCase():
      return LanguageLocales.UKRAINIAN;
    default:
      return LanguageLocales.NORWEGIAN;
  }
};

export const hentOversettelse = (key: keyof HNSkjemaFrontend, resources: HNSkjemaFrontend): string => {
  const value = resources[key];
  return sjekkInputErIkkeTom(value) ? value : defaultResource[key];
};
